import { Identifier, RaRecord } from 'react-admin';

export type DataType = {
  id: string;
  //optionText:string
};

export type ClientDataType = DataType & {
  client_name: string;
  client_number: string;
};

export type PharmacyDataType = DataType & {
  pharmacy_npi: string;
  pharmacy_network_name: string;
};

export type TPADataType = DataType & {
  vendor_name: string;
  vendor_number: string;
  vendor_tin: string;
  vendor_type: string;
};

export type BrokerDataType = DataType & {
  vendor_name: string;
  vendor_number: string;
  vendor_tin: string;
  vendor_type: string;
};

export type SetDatePropsType = {
  setStartDateFunction?: React.Dispatch<React.SetStateAction<string>>;
  setEndDateFunction?: React.Dispatch<React.SetStateAction<string>>;
  setToggleFunction: React.Dispatch<React.SetStateAction<boolean>>;
  source?: string;
  label?: string;
};

export interface ActionColumnPropsType {
  editRowIds: (string | number)[];
  handleEdit: (rowId: any) => void;
  handleSave: (rowId: string | number) => Promise<void>;
  handleCancel: (rowId: string | number) => void;
}

export interface CustomEditableFieldPropsType {
  source: string;
  label: string;
  editRowIds: (string | number)[];
  allEditedRows: Record<string | number, Record<string, any>>;
  handleFieldChange: (field: string, value: string, rowId: string | number) => void;
}
export type FeeDataType = {
  id: string | number;
  changes: Record<string, any>;
};

export interface ConfirmationDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
  cancelButtonLabel?: string;
  okButtonLabel?: string;
}

export interface ListActionsProps {
  handleSaveAll: () => void;
  handleCancelAll: () => void;
  activeEditRowIds: (string | number)[];
}

export interface PageChangeHandlerProps {
  activeEditRowIds: (string | number)[];
  handleCancelAll: () => void;
}

export type BillingClientForm = {
  accounting_client_id: string;
  billing_cycle: string;
  invoice_detail_location_yn: string;
  invoice_detail_member_name_yn: string;
  invoice_breakout: string;
  invoice_breakout_description: string;
};

export type EditDialogProps = {
  isDialogOpen: boolean;
  formValues: {
    accounting_client_id: string;
    billing_cycle: string;
    invoice_detail_location_yn: string;
    invoice_detail_member_name_yn: string;
    invoice_breakout: string;
    invoice_breakout_description: string;
  };
  setFormValues: (values: any) => void;
  handleDialogClose: () => void;
  handleSave: () => void;
};

export type MemberSummaryCleintProps = {
  selectedClient: ClientDataType | null;
  setSelectedClient: (client: ClientDataType | null) => void;
  label?: string;
  disabled?: boolean;
  reportType: string;
  showExceptionClients?: boolean;
  refreshKey?: number;
};

export interface MedicalGroupFormValues {
  id?: string | number;
  billing_client_number: string;
  billing_client_name: string;
  medical_group_number: string;
  medical_group_name: string;
  plan_location: string;
}

export interface EditMedicalGroupDialogProps {
  isOpen: boolean;
  formValues: MedicalGroupFormValues;
  originalValues: MedicalGroupFormValues;
  setFormValues: (values: any) => void;
  onClose: () => void;
  onSave: () => Promise<void>;
}

export interface LocationFormValues {
  id?: string | number;
  billing_client_number: string;
  billing_client_name: string;
  location_number: string;
  location_name: string;
  location_display_number: string;
}

export interface EditLocationDialogProps {
  isOpen: boolean;
  formValues: LocationFormValues;
  originalValues: any;
  setFormValues: (values: any) => void;
  onClose: () => void;
  onSave: () => Promise<void>;
}

export interface DivisionFormValues {
  id?: string | number;
  billing_client_number: string;
  billing_client_name: string;
  division_number: string;
  division_name: string;
  division_display_number: string;
}
export interface EditDivisionDialogProps {
  isOpen: boolean;
  formValues: DivisionFormValues;
  originalValues: any;
  setFormValues: (values: any) => void;
  onClose: () => void;
  onSave: () => void;
}

export interface ClientListProps {
  setFunction: (values: any) => void;
  reset?: boolean;
  filter?: object;
  report_type?: string;
}

export interface TpaListProps {
  setFunction: (values: RaRecord<Identifier>[]) => void;
  reset?: boolean;
  value: RaRecord<Identifier>[];
}

export type SetPropsType = {
  setFunction: React.Dispatch<React.SetStateAction<RaRecord<Identifier>[]>>;
  label?: string;
  reset?: boolean;
  getOptionLabel: (option: any) => string;
  optionValueKey: string;
};

export type MemberSummaryFormState = {
  detailed_fields?: string[];
  rollup_config?: {
    group_by_fields?: string[];
    sum_fields?: string[];
  };
  report_view_type?: string;
  pa_status_enabled?: boolean;
  zip_invoices_enabled?: boolean;
  [key: string]: any;
};

export interface TpaSourceFilterProps {
  selectedTpa: TPADataType | null;
  setSelectedTpa: (tpa: TPADataType | null) => void;
  label?: string;
  disabled?: boolean;
  refreshKey?: number;
}

export interface TpaFormData {
  clientName: string;
  clientNumber: string;
  oldTpaName: string;
  oldTpaBillingNumber: string;
  newTpaName: string;
  newTpaBillingNumber: string;
}

export interface TpaForClient {
  id: string | number;
  vendor_name: string;
  vendor_number: string | number;
}

export const initialTpaFormData: TpaFormData = {
  clientName: '',
  clientNumber: '',
  oldTpaName: '',
  oldTpaBillingNumber: '',
  newTpaName: '',
  newTpaBillingNumber: '',
  newBillingClientName: '',
  gpAccountingClientId: '',
};

export interface TpaFormData {
  clientName: string;
  clientNumber: string;

  oldTpaName: string;
  oldTpaBillingNumber: string;

  newTpaName: string;
  newTpaBillingNumber: string;

  newBillingClientName: string;
  gpAccountingClientId: string;
}

export interface TpaTransitionFormProps {
  formData: TpaFormData;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  tpaList: TpaForClient[];
  isTpaLoading: boolean;
  associatedTpa: TpaForClient | null;
  onTpaSelect: (fieldName: 'oldTpaName' | 'newTpaName', newValue: TpaForClient | null) => void;
}

export interface ReorderFieldsDialogProps {
  open: boolean;
  primaryView: 'detailed' | 'rollup';
  formState: any;
  tempOrder: string[];
  setTempOrder: React.Dispatch<React.SetStateAction<string[]>>;
  onClose: () => void;
  onSave: (newOrder: string[]) => void;
}

export interface MemberSummaryRef {
  hasUnsavedChanges: boolean;
  getUnsavedChangesConfirmation: () => Promise<boolean>;
}

export interface UnsavedChangesDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export interface ClientCombineFormProps {
  primaryClient: ClientDataType;
  allClients: ClientDataType[];
  selectedCombineClients: ClientDataType[];
  onCombineClientsChange: (clients: ClientDataType[]) => void;
}

export type FileListItem = {
  file: File | null;
  column: string;
};

export interface FileUploadDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (fileList: FileListItem[]) => void;
  initialFileColumnList: FileListItem[];
}

export interface ClientCleanupFormProps {
  primaryClient: ClientDataType;
  effectiveDate: string;
  onSaveRule: (payload: CleanupRequestPayload) => void;
  isSaving: boolean;
}

export interface PharmacyOption {
  value: string;
  name: string;
}
export interface ClientSplitRule {
  fieldToSplit: string;
  sourceField: string;
  conditionLength: string;
  leftTrim: string;
  rightTrim: string;
  matchValue: string;
  matchOperator?: 'contains' | 'equals' | 'not_equals' | null;
  newClientName: string;
  newClientNumber: string;
  identifierType?: 'npi' | 'nabp';
  identifierValues?: PharmacyOption[];
  isExisting?: boolean;
  ruleEntryMode?: 'ui' | 'custom_sql';
  customSql?: string;
}

export interface ClientSplitRulePayload {
  ruleEntryMode: 'ui' | 'custom_sql';
  sourceField?: string;

  newClientName: string;
  newClientNumber: string;

  matchValue?: string;
  matchOperator?: 'equals' | 'contains' | 'not_equals';
  conditionLength?: number;
  leftTrim?: number;
  rightTrim?: number;

  identifierType?: 'npi' | 'nabp';
  identifierValues?: string[];

  customSql?: string;
}

export interface ClientSplitFormProps {
  primaryClient: ClientDataType;
  effectiveDate: string;
  onSaveRule: (rules: ClientSplitRulePayload[]) => Promise<any>;
  isSaving: boolean;
}

export interface ConsolidatedRow {
  billing_client_numbers_list: string;
  medical_group_number?: string;
  medical_group_names_list?: string;

  location_number?: string;
  location_names_list?: string;

  division_number?: string;
  division_names_list?: string;

  [key: string]: any;
}

export interface CrosswalkSummaryTableProps {
  clientNumber: string;
  category: 'medical_groups' | 'locations' | 'divisions';
}

export interface CrosswalkFiltersProps {
  selectedClient: any | null;
  onClientChange: (newValue: any | null) => void;
  onApply: () => void;
  onClear: () => void;
  setSelectedClient: (client: any) => void;
  reset?: boolean;
}

export interface ClientBillSplitParams {
  leftTrim: number;
  rightTrim: number;
  matchValue: string;
  sourceField: string;
  fieldToSplit: string;
  newClientName: string;
  identifierType: string;
  conditionLength: number;
  newClientNumber: string;
  identifierValues: string[];
}

export interface ClientCombineParams {
  primaryClient: {
    client_name: string;
    client_number: string;
  };
  combinedClients: {
    client_name: string;
    client_number: string;
  }[];
}

export interface TpaTransitionParams {
  clientName: string;
  clientNumber: string;
  oldTpaName: string;
  newTpaName: string;
  oldTpaBillingNumber: string;
  newTpaBillingNumber: string;
}

export interface CleanupParams {
  leftTrim: number;
  rightTrim: number;
  conditionLength: number;
  sourceField: string;
  fieldToUpdate: string;
}

export interface RuleRecord {
  split_type: string;
  extract_params: any;
}

type RuleMode = 'simple' | 'advanced' | 'swap';
type SplitFrom = 'left' | 'right';
type TrimOrder = 'LR' | 'RL';
type MinLengthField = 'source' | 'target';
export type RuleEntry = 'ui' | 'custom_sql';

export type CleanupRule = {
  fieldToUpdate: string;
  sourceField: string;

  ruleEntryMode?: RuleEntry;
  mode: RuleMode;

  customSql?: string;

  // SIMPLE MODE
  splitFrom?: SplitFrom;
  splitLength?: string;

  // ADVANCED MODE
  matchValue?: string;
  matchField?: 'medical_group_number' | 'location_number' | 'division_number' | null;
  matchOperator?: 'contains' | 'equals' | 'not_equals' | null;

  conditionLength?: string;
  leftTrim?: string;
  rightTrim?: string;

  minLengthField?: 'medical_group_number' | 'location_number' | 'division_number';
  minLengthOperator?: '>=' | '>' | '<=' | '<' | '=';

  trimOrder?: TrimOrder;
  trimAction?: 'TAKE' | 'REMOVE';
  onlyIfTargetEmpty?: boolean;

  alsoUpdateMedical?: boolean;

  clientNumber?: string;
};

export type CleanupTargetField = 'medical_group_number' | 'location_number' | 'division_number';

export interface CleanupRulePayload {
  field_to_update: CleanupTargetField;
  source_field: string;
  split_mode: 'simple' | 'advanced' | 'swap';

  rule_entry_mode?: RuleEntry;

  custom_sql?: string;

  // conditions
  min_length?: number | null;
  min_length_field?: 'medical_group_number' | 'location_number' | 'division_number' | null;
  min_length_operator?: '>=' | '>' | '<=' | '<' | '=';

  match_value?: string | null;
  match_field?: 'medical_group_number' | 'location_number' | 'division_number' | null;
  match_operator?: 'contains' | 'equals' | 'not_equals' | null;

  client_number?: string | null;
  only_if_target_empty?: boolean;

  // simple
  split_from?: 'left' | 'right';
  split_length?: number;
  also_update_medical?: boolean;

  // advanced
  left_trim?: number;
  right_trim?: number;
  trim_order?: 'LR' | 'RL';
  trim_action?: 'TAKE' | 'REMOVE';
}

export type CleanupRequestPayload = {
  originalClientNumber: string;
  clientName: string;
  effectiveDate: string;
  rules: CleanupRulePayload[];
};

export type ExceptionReportName = 'Invoice' | 'PA' | 'Assist';

export type ExceptionExtractParams = {
  layout?: string;
  fields: string[];
};

export type ReportExceptionConfig = {
  record_id: number;
  client_number: string;
  report_name: ExceptionReportName;
  extract_parms: ExceptionExtractParams;
  created_by: string;
  effective_start_datetime: string;
  effective_end_datetime: string;
};

export type ExceptionCategory = {
  id: string;
  name: string;
  fields: string[];
};

export type ExceptionConfigSectionProps = {
  title: string;
  categories: ExceptionCategory[];
  fieldLabels: Record<string, string>;
  formState: { fields: string[] };
  setFormState: React.Dispatch<any>;
  isLoading: boolean;
  isDefault: boolean;
  canSave: boolean;
  onReset: () => void;
  onSave: () => void;

  hideBulkActions?: boolean;

  selectedLayout?: string;
  onLayoutChange?: (layoutId: string) => void;
  isLayoutLocked?: boolean;
  layoutOptions?: {
    id: string;
    label: string;
    fields: string[];
  }[];
};

export interface CreateDivisionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (newDivisionData: any) => void;
  selectedClient: any;
}

export interface CreateLocationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (newLocationData: any) => void;
  selectedClient: any;
}

export interface CreateMedicalGroupDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (newMedicalGroupData: any) => void;
  selectedClient: any;
}
